import moment from "moment";

export class StringUtils {
    public static maskString(stringToMask: string): string {
        return stringToMask.charAt(0) + "***";
    }

    public static formatDate(input: string): string {
        if(input === undefined || input === ""){
            return "--";
        } else {
            return moment(input).format("DD/MM/yyyy");
        }
    }

    public static checkIfEmailInString(text: any) { 
        let regex = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
        return regex.test(text);
    }

}